<div class="search-box_container">

  <div class="search-box_toolbar">

    <button
      *ngIf="(itemsDisplayService.itemsVisible$ | async) && !matcherMode" 
      class="button-primary button-primary--white" 
      (click)="onBackClick()">
      <fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
    </button>
  
    <button
      #sortBox
      *ngIf="itemsDisplayService.itemsVisible$ | async"
      class="button-primary button-primary--white button-dropdown relative"
      [ngClass]="{'button-dropdown--active': isSortDropdownVisible, 'hidden': isGlobalSearch && !term }">
      <fa-icon 
        class="button-dropdown_icon"
        [icon]="['fal', itemsDisplayService.order === 'asc' ? 'sort-alpha-down' : 'sort-alpha-up']"
        (click)="isSortDropdownVisible = !isSortDropdownVisible"></fa-icon>
      <div
        class="scs-dropdown"
        [ngClass]="{ 'hidden': !isSortDropdownVisible}">
        <div 
          *ngFor="let opt of sortOptions | keyvalue"
          class="scs-dropdown_item"
          [ngClass]="{'scs-dropdown_item--active': itemsDisplayService.sort == opt.key }"
          (click)="onSortChange(opt.key)">
          {{opt.value}}
        </div>
        <div class="scs-dropdown_divider"></div>
        <div 
          class="scs-dropdown_item"
          *ngFor="let opt of orderOptions | keyvalue"
          [ngClass]="{'scs-dropdown_item--active': itemsDisplayService.order == opt.key }"
          (click)="onOrderChange(opt.key)">
          {{opt.value}}
        </div>
      </div>
    </button>
  
    <div class="search-box_bar button-primary button-primary--white">
      <div #searchKeyBox>
        <div 
          class="search-box_icon-down"
          (click)="isSearchKeyDropdownVisible = !isSearchKeyDropdownVisible">
        </div>
        <div
          class="scs-dropdown"
          [ngClass]="{ 'hidden': !isSearchKeyDropdownVisible}">
          <div 
            *ngFor="let opt of searchKeys | keyvalue"
            class="scs-dropdown_item" 
            (click)="onSearchKeyClick($event, opt.key)">
            {{opt.value}}
          </div>
          <div class="scs-dropdown_divider"></div>
          <div class="scs-dropdown_item" (click)="onSearchKeyClick($event, ' AND (CARET)')">AND</div>
          <div class="scs-dropdown_item" (click)="onSearchKeyClick($event, ' OR (CARET)')">OR</div>
          <div class="scs-dropdown_item" (click)="onSearchKeyClick($event, ' NOT((CARET))')">NOT</div>
        </div>
      </div>

      <input
        #searchInput
        type="text" 
        [(ngModel)]="term"
        [placeholder]="isGlobalSearch ? 'Search the web' : getItemSearchPlaceholder()"
        (keydown.enter)="search()"
        (input)="onInput()"
        (focus)="onInput()">
      <div 
        *ngIf="!isGlobalSearch, else globalSearchIcon"
        class="search-box_icon-search"
        [ngClass]="{'default-cursor': matcherMode}"
        title="Use web search"
        (click)="toggleSearch()">
        <svg width="20px" height="20px" viewBox="0 0 20 20" aria-hidden="true" role="presentation"><path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"></path></svg>
      </div>
      <ng-template #globalSearchIcon>
        <div 
          class="search-box_icon-search"
          title="Use library search"
          (click)="toggleSearch()">
          <svg width="20px" viewBox="0 0 20 20"><path d="M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,4.5L8.95,4.53C8.71,5.05 8.34,5.93 8.07,7H10.93C10.66,5.93 10.29,5.05 10.05,4.53C9.87,4.5 9.69,4.5 9.5,4.5M13.83,7C13.24,5.97 12.29,5.17 11.15,4.78C11.39,5.31 11.7,6.08 11.93,7H13.83M5.17,7H7.07C7.3,6.08 7.61,5.31 7.85,4.78C6.71,5.17 5.76,5.97 5.17,7M4.5,9.5C4.5,10 4.58,10.53 4.73,11H6.87L6.75,9.5L6.87,8H4.73C4.58,8.47 4.5,9 4.5,9.5M14.27,11C14.42,10.53 14.5,10 14.5,9.5C14.5,9 14.42,8.47 14.27,8H12.13C12.21,8.5 12.25,9 12.25,9.5C12.25,10 12.21,10.5 12.13,11H14.27M7.87,8L7.75,9.5L7.87,11H11.13C11.21,10.5 11.25,10 11.25,9.5C11.25,9 11.21,8.5 11.13,8H7.87M9.5,14.5C9.68,14.5 9.86,14.5 10.03,14.47C10.28,13.95 10.66,13.07 10.93,12H8.07C8.34,13.07 8.72,13.95 8.97,14.47L9.5,14.5M13.83,12H11.93C11.7,12.92 11.39,13.69 11.15,14.22C12.29,13.83 13.24,13.03 13.83,12M5.17,12C5.76,13.03 6.71,13.83 7.85,14.22C7.61,13.69 7.3,12.92 7.07,12H5.17Z"></path></svg>
        </div>
      </ng-template>
      <div
        #searchPicksBox
        class="scs-dropdown"
        *ngIf="displayedSearchPicks?.length"
        [ngClass]="{ 'hidden': !isSearchPickDropdownVisible}">
        <div 
          *ngFor="let pick of displayedSearchPicks"
          class="scs-dropdown_item"
          (click)="onSearchPickClick(pick)">
          <fa-icon class="scs-dropdown_icon" [icon]="['fal', 'history']" *ngIf="pick.type === 'history'"></fa-icon>
          <fa-icon class="scs-dropdown_icon" [icon]="['fal', 'tag']" *ngIf="pick.type === 'tag'"></fa-icon>
          <span class="scs-dropdown_text" [innerHTML]="pick.richTextValue"></span>
        </div>
      </div>
      <div 
        class="search-box_icon-close"
        (click)="onClearSearch()">
        <fa-icon [icon]="['fal', 'times']"></fa-icon>
      </div>
    </div>

  </div>

</div>